<template>
  <b-tabs content-class="texts-tab mt-3" class="texts-content">
    <b-tab active>
      <template v-slot:title>
        <i class="flag-icon flag-icon-lv mr-2"></i><span>lv</span>
        <span v-if="lvHasErrors" style="color: red;">&bull;</span>
      </template>
      <TextsInputField v-for="field in fields"
                       v-if="typeof innerTexts.lv !== 'undefined'"
                       :label="field.label"
                       :placeholder="field.placeholder"
                       :isRequired="field.isRequired"
                       :type="field.type"
                       :variables="field.variables"
                       :value="innerTexts.lv[field.id]"
                       :options="field.options"
                       v-on:input="updateValue($event, 'lv', field.id)"
                       :error="errors ? errors['lv.' + field.id] : false" />
    </b-tab>
    <b-tab title="en">
      <template v-slot:title>
        <i class="flag-icon flag-icon-gb mr-2"></i><span>en</span>
        <span v-if="enHasErrors" style="color: red;">&bull;</span>
      </template>
      <TextsInputField v-for="field in fields"
                       v-if="typeof innerTexts.en !== 'undefined'"
                       :label="field.label"
                       :placeholder="field.placeholder"
                       :isRequired="field.isRequired"
                       :type="field.type"
                       :variables="field.variables"
                       :value="innerTexts.en[field.id]"
                       :options="field.options"
                       v-on:input="updateValue($event, 'en', field.id)"
                       :error="errors ? errors['en.' + field.id] : false" />
    </b-tab>
  </b-tabs>
</template>

<script>
import TextsInputField from '@/components/Texts/TextsInputFieldComponent';

export default {
  components: { TextsInputField },
  props: {
    value: {
      default: {
        lv: [],
        en: []
      },
      type: Object,
      required: true
    },
    fields: {
      default: [],
      type: Array,
      required: true
    },
    errors: {
      type: Object
    }
  },
  data() {
    return {
      innerTexts: {},
      lvHasErrors: false,
      enHasErrors: false
    }
  },
  watch: {
    value: {
      handler() {
        this.innerTexts = this.value;
      },
      deep: true,
      immediate: true
    },
    errors(value) {
      const lvHas = this.fields.some((el) => {
        return value['lv.' + el.id] ? true : false;
      });
      
      this.lvHasErrors = lvHas;

      const enHas = this.fields.some((el) => {
        return value['en.' + el.id] ? true : false;
      });
      
      this.enHasErrors = enHas;
    }
  },
  methods: {
    updateValue: function (value, lang, id) {
      this.innerTexts[lang][id] = value;
      this.$emit('input', this.innerTexts);
    }
  }
}
</script>

<style>
  .texts-content textarea.form-control {
    height: calc(10em + 0.75rem + 2px);
  }
</style>
